module.exports = __webpack_public_path__ + "static/media/Course_Calendar.0c7e06a7.svg";